import React, { Fragment, useEffect } from "react";
import AxonMetricHeader from "./AxonMetricHeader";
import Footer from "./Footer";

const Layout = ({ header, footer, children, bgBlack, single }) => {
  useEffect(() => {
    if (bgBlack) {
      document.querySelector("body").classList.add("home-5-body-color");
    } else {
      if (
        document.querySelector("body").classList.contains("home-5-body-color")
      ) {
        document.querySelector("body").classList.remove("home-5-body-color");
      }
    }
  }, []);

  return (
    <Fragment>
      <AxonMetricHeader header={header} single={single} />
      {children}
      {footer && <Footer footer={footer} />}
    </Fragment>
  );
};

export default Layout;
